<template>
  <div class="pages">
    <el-row :gutter="30" v-if="false">
      <template v-for="(val, idx) in dataList">
        <el-col :span="4" :key="idx">
          <div class="flex-col items-start section" :class="'userback' + idx">
            <span class="name">{{ val.name }}</span>
            <span class="number">{{ val.value }}</span>
          </div>
        </el-col>
      </template>
      <!-- <template>
        <el-col :span="4">
          <div class="flex-col items-start section userback1">
            <span class="name">全部用户</span>
            <span class="number">{{ dataList.userCount }}</span>
          </div>
        </el-col> </template
      ><template>
        <el-col :span="4">
          <div class="flex-col items-start section userback2">
            <span class="name">已认证用户</span>
            <span class="number">{{ dataList.attestationUserCount }}</span>
          </div>
        </el-col> </template
      ><template>
        <el-col :span="4">
          <div class="flex-col items-start section userback3">
            <span class="name">未认证用户</span>
            <span class="number">{{ dataList.noAttestationUserCount }}</span>
          </div>
        </el-col>
      </template>
      <template>
        <el-col :span="4">
          <div class="flex-col items-start section userback4">
            <span class="name">待审核用户</span>
            <span class="number">{{ dataList.noAttestationUserCount }}</span>
          </div>
        </el-col>
      </template>
      <template>
        <el-col :span="4">
          <div class="flex-col items-start section userback5">
            <span class="name">待二次审核用户</span>
            <span class="number">{{ dataList.noAttestationUserCount }}</span>
          </div>
        </el-col>
      </template>
      <template>
        <el-col :span="4">
          <div class="flex-col items-start section userback6">
            <span class="name">未通过用户</span>
            <span class="number">{{ dataList.noAttestationUserCount }}</span>
          </div>
        </el-col>
      </template> -->
    </el-row>
    <div class="top-block">
      <div class="filter">
        <div>
          <el-form size="small" :inline="true">
            <!-- <el-form-item label="认证状态">
            <el-select v-model="formInline.status">
              <el-option
                :label="v.name"
                :value="v.value"
                v-for="(v, i) in statueList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item label="学校">
              <el-select
                clearable
                v-model="schoolValue"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色" v-if="activeName == 'first'">
              <el-select v-model="formInline.role">
                <el-option
                  :label="v.name"
                  :value="v.value"
                  v-for="(v, i) in roleList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择日期" v-if="activeName == 'first'">
              <el-date-picker
                type="daterange"
                v-model="formInline.dateValue"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="激活状态" v-if="activeName == 'second'">
              <el-select
                clearable
                v-model="formInline.IsUse"
                placeholder="请选择激活状态"
              >
                <el-option
                  v-for="item in activatedList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="search">
          <el-form size="small" :inline="true">
            <el-form-item label="关键字">
              <el-input
                v-model.trim="formInline.keyWord"
                placeholder="请输入关键词查询"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchList">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="user-count-list">
        <div class="user-count-item" v-for="(v, i) in dataList" :key="i">
          <span class="name">{{ v.name }}</span>
          <span class="value">{{ v.value }}</span>
        </div>
      </div>
    </div>

    <div class="table">
      <el-tabs v-model="activeName" @tab-click="tabHandleClick">
        <el-tab-pane label="注册用户" name="first">
          <el-table :data="tableData" height="6.58rem" max-height="6.58rem"
            ><!-- 4.1 -->
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="50"
            >
            </el-table-column>
            <el-table-column property="userName" label="用户名" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.userName">{{ scope.row.userName }}</p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column property="name" label="真实姓名" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.name">{{ scope.row.name }}</p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column
              property="attestationCount"
              label="已认证学校"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="waitAttestationCount"
              label="待认证学校"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="noAttestationCount"
              label="未通过学校"
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column property="state" label="认证状态" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.state === 2" style="color: #ea2727">未认证</p>

            <p v-else-if="scope.row.state === 1" style="color: #2ee12e">
              已认证
            </p>
            <p v-else-if="scope.row.state === 3" style="color: #198cff">
              待审核
            </p>
            <p v-else-if="scope.row.state === 5" style="color: #ea2727">
              审核不通过
            </p>
            <p v-else-if="scope.row.state === 4" style="color: #f28e0c">
              待二次审核
            </p>
          </template>
        </el-table-column> -->
            <el-table-column label="角色" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.role }}</p>
                <!-- <p v-if="scope.row.role === 0">无角色</p>
                <p v-else-if="scope.row.role === 1">校友</p>
                <p v-else-if="scope.row.role === 2">企业</p>
                <p v-else-if="scope.row.role === 3">教职工</p>
                <p v-else-if="scope.row.role === 4">管理员</p>
                <p v-else-if="scope.row.role === 5">在校生</p> -->
              </template>
            </el-table-column>
            <el-table-column
              property="creationTime"
              label="注册时间"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="medium"
                  >详情</el-button
                >
                <el-button
                  @click="resetPassword(scope.row)"
                  type="text"
                  size="medium"
                  >重置密码</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="预配置用户" name="second">
          <el-button type="primary" size="medium" @click="importHandle"
            >导入</el-button
          >
          <el-button
            type="primary"
            size="medium"
            @click="handleBatchDelete"
            :disabled="selectedIds.length === 0"
            :loading="deleteLoading"
            >批量删除</el-button
          >
          <el-table
            :data="tableData2"
            height="6.58rem"
            max-height="6.58rem"
            @selection-change="handleSelectionChange"
          >
            <!-- 添加多选列 -->
            <el-table-column
              type="selection"
              width="55"
              align="center"
              :selectable="checkSelectable"
            ></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="50"
            >
            </el-table-column>

            <el-table-column property="name" label="真实姓名" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.name">{{ scope.row.name }}</p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column
              property="idCard"
              label="身份证号"
              align="center"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.idCard">{{ scope.row.idCard}}</p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column property="school" label="学校" align="center">
            </el-table-column>
            <el-table-column property="education" label="学历" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.education">{{ scope.row.education }}</p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column property="college" label="学院" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.college">{{ scope.row.college }}</p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column property="major" label="专业" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.major">{{ scope.row.major }}</p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column
              property="joinSchoolYear"
              label="入学年份"
              align="center"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.joinSchoolYear">
                  {{ scope.row.joinSchoolYear }}
                </p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column
              property="endSchoolYear"
              label="毕业年份"
              align="center"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.endSchoolYear">
                  {{ scope.row.endSchoolYear }}
                </p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column property="isUsed" label="激活状态" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.isUsed === true">{{ "已激活" }}</p>
                <p v-if="scope.row.isUsed === false">{{ "未激活" }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  style="color: #f00"
                  @click="handleDelete([scope.row.id])"
                  type="text"
                  size="medium"
                  :disabled="scope.row.isUsed"
                  :loading="scope.row.deleting"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table></el-tab-pane
        >
      </el-tabs>

      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 导入弹窗 -->
    <el-dialog
      title="导入"
      :visible.sync="importDialog"
      width="30%"
      @close="closeImportDialog"
    >
      <el-form
        ref="uploadForm"
        :model="uploadForm"
        label-width="80px"
        :rules="importRules"
      >
        <el-form-item label="附件" prop="academyCode">
          <el-upload
            :headers="headers"
            class="upload-demo"
            :action="url"
            :auto-upload="false"
            :on-success="onSuccess"
            ref="upload"
            :before-upload="beforeUpload"
            :on-change="changeFile"
            accept=".xlsx,.xls"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx或xls文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="模版下载">
          <a
            :href="downloadHred"
            style="color: #4a89dc;"
            download="预配置用户导入模版"
            >下载excel模板</a
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialog = false" style="margin-left: 50px;"
          >取 消</el-button
        >
        <el-button type="primary" @click="onImportCollege">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetPreConfiguredUserListApi,
  PreConfiguredUserTemplateApi,
  ImportPreConfiguredUserApi,
  DeletePreConfiguredUserApi
} from "@/request/requestApi.js";
export default {
  data() {
    return {
      tableData2: [],
      multipleSelection: [], // 存储选中的行数据
      selectedIds: [], // 存储选中的ID
      deleteLoading: false, // 删除加载状态
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      uploadForm: {},
      importDialog: false,
      activeName: "first",
      schoolValue: "",
      //学校
      schoolList: [],
      tableData: [],
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      activatedList: [
        { name: "未激活", value: false },
        { name: "已激活", value: true }
      ],
      dataList: [
        {
          name: "全部用户",
          number: "1000"
        },
        {
          name: "已认证用户",
          number: "1000"
        },
        {
          name: "未认证用户",
          number: "1000"
        },
        {
          name: "待审核用户",
          number: "1000"
        },
        {
          name: "待二次审核用户",
          number: "1000"
        },
        {
          name: "未通过用户",
          number: "1000"
        }
      ],
      statueList: [
        { name: "全部", value: "" },
        { name: "已认证", value: 1 },
        { name: "未认证", value: 2 },
        { name: "待审核", value: 3 },
        { name: "待二次审核", value: 4 },
        { name: "审核不通过", value: 5 }
      ],
      roleList: [
        { name: "全部", value: "" },
        { name: "在校生", value: 5 },
        { name: "校友", value: 1 },
        { name: "企业", value: 2 },
        { name: "教职工", value: 3 },
        { name: "管理员", value: 4 }
      ],
      formInline: {
        status: "",
        role: "",
        keyWord: "",
        dateValue: "",
        SchoolId: "",
        IsUse: undefined
      },
      downloadHred: "",
      apiUrl: "",
      url: ""
    };
  },
  created() {
    this.apiUrl = window.api.apiurl;
    this.url = window.api.userConfigUrl;
    this.getUserCountList();
    this.getSchoolList();
    this.getPreConfiguredUserTemplate();
    if (this.$route.params.pageIdx || this.$route.params.pageSize) {
      this.currentPage = this.$route.params.pageIdx;
      this.currentSize = this.$route.params.pageSize;
      this.getUserList(this.currentPage, this.currentSize);
    } else {
      this.getUserList();
    }
  },
  methods: {
    // 控制行是否可被选中
    checkSelectable(row, index) {
      // 如果用户已激活(isUsed为true)，则禁止选中
      return !row.isUsed;
    },
    // 处理多选变化
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectedIds = val.map(item => item.id);
    },
    // 统一删除方法
    async handleDelete(ids) {
      try {
        this.deleteLoading = true;

        // 确认对话框
        await this.$confirm(`确定要删除选中的${ids.length}条数据吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });

        // 调用删除接口
        const res = await DeletePreConfiguredUserApi({ ids });

        if (res.succeed) {
          this.$message.success("删除成功");
          // 重新加载数据
          this.getPreConfiguredUserList();
          // 清空选择
          this.multipleSelection = [];
          this.selectedIds = [];
        } else {
          this.$message.error(res.error || "删除失败");
        }
      } catch (error) {
        // 用户取消了删除
        if (error !== "cancel") {
          this.$message.error("删除失败: " + (error.message || "未知错误"));
        }
      } finally {
        this.deleteLoading = false;
      }
    },

    // 批量删除
    handleBatchDelete() {
      if (this.selectedIds.length === 0) {
        this.$message.warning("请至少选择一条数据");
        return;
      }
      this.handleDelete(this.selectedIds);
    },

    // 修改获取列表方法，确保返回的数据有id字段
    async getPreConfiguredUserList(PageIndex = 1, PageSize = 10) {
      try {
        let params = {
          SchoolId: this.formInline.SchoolId,
          IsUse: this.formInline.IsUse,
          Key: this.formInline.keyWord,
          PageIndex: PageIndex,
          PageSize: PageSize
        };
        let res = await GetPreConfiguredUserListApi(params);
        if (res.succeed) {
          this.tableData2 = res.data.data.map(item => ({
            ...item,
            id: item.id || item.userId // 确保有id字段，根据实际接口调整
          }));
          this.totalCount = res.data.total;
        }
      } catch (error) {
        this.$message.error("获取数据失败: " + (error.message || "未知错误"));
      }
    },
    tabHandleClick() {
      this.formInline = {
        status: "",
        role: "",
        keyWord: "",
        dateValue: "",
        SchoolId: "",
        IsUse: ""
      };
      this.schoolValue = "";
      this.currentPage = 1;
      if (this.activeName == "first") {
        this.getUserList();
      } else if (this.activeName == "second") {
        this.getPreConfiguredUserList();
      }
    },
    async getPreConfiguredUserTemplate() {
      let res = await PreConfiguredUserTemplateApi();
      if (res.succeed) {
        this.downloadHred = this.apiUrl + res.data;
      }
    },
    async getPreConfiguredUserList(PageIndex = 1, PageSize = 10) {
      let params = {
        SchoolId: this.schoolValue,
        IsUse: this.formInline.IsUse,
        PageIndex: PageIndex,
        PageSize: PageSize
      };
      let res = await GetPreConfiguredUserListApi(params);
      if (res.succeed) {
        this.tableData2 = res.data.data;
        this.totalCount = res.data.total;
      }
    },
    importHandle() {
      this.importDialog = true;
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isXlsx = fileType === "xlsx";
      const isXls = fileType === "xls";
      if (!isXlsx && !isXls) {
        this.$message.error("只能上传xlsx或xls格式的文件！");
        return false;
      }
      return true;
    },
    changeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    closeImportDialog() {
      this.$refs.upload.clearFiles();
      this.uploadForm.filePath = "";
    },
    async onImportCollege() {
      try {
        // 检查是否已选择文件
        const uploadFiles = this.$refs.upload.uploadFiles;
        if (!uploadFiles || uploadFiles.length === 0) {
          this.$message.error("请先选择要上传的文件");
          return;
        }

        this.$confirm(
          "为确保数据安全与一致性，添加数据后将无法修改和删除。请确认当前数据准确无误后再执行该操作。是否确认添加数据?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(async () => {
            // 显示加载状态
            const loadingInstance = this.$loading({
              lock: true,
              text: "文件上传中...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });

            // 手动触发上传
            await new Promise((resolve, reject) => {
              this.$refs.upload.submit();
              // 假设 onSuccess 会处理上传结果
              this.$once("upload-complete", () => {
                loadingInstance.close();
                resolve();
              });
              this.$once("upload-error", error => {
                loadingInstance.close();
                reject(error);
              });
            });

            // 上传成功后关闭对话框
            this.importDialog = false;
          })
          .catch(() => {});
      } catch (error) {
        // this.$message.error("文件上传失败: " + (error.message || "未知错误"));
      }
    },
    onSuccess(val) {
      if (val.succeed) {
        this.uploadForm.filePath = val.data;
        this.$message.success("文件上传成功！");
        this.$emit("upload-complete"); // 触发上传完成事件
      } else {
        this.$message.error(val.error || "文件上传失败");
        this.$refs.upload.clearFiles();
        this.uploadForm.filePath = "";
        this.$emit("upload-error", val.error); // 触发上传错误事件
      }
      this.searchList();
    },
    searchList() {
      this.currentPage = 1;
      if (this.activeName == "first") {
        this.getUserList(this.currentPage);
      } else if (this.activeName == "second") {
        this.getPreConfiguredUserList(this.currentPage);
      }
    },
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    getUserList(pageIndex = 1, pageSize = 10) {
      let params = {
        pageIndex: pageIndex,
        pageSize: pageSize,
        schoolid: this.schoolValue,
        DateBegin:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[0],
        DateEnd:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[1],
        state: this.formInline.status,
        role: this.formInline.role,
        Keyword: this.formInline.keyWord
      };
      let url = this.$dataConver.getUrl("/admin/User/GetUserList", params);
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.tableData = res.data.items;
          this.totalCount = res.data.total;
          console.log(this.tableData);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    getUserCountList() {
      this.$api.get("/admin/User/GetUserCount").then(res => {
        if (res.succeed) {
          this.dataList = res.data;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    handleClick(val) {
      this.$router.push({
        path: "/userManagement/userDetail",
        query: {
          role: "user",
          id: val.id,
          pageIdx: this.currentPage,
          pageSize: this.currentSize
        }
      });
    },
    resetPassword(val) {
      this.$alert("默认密码：1a2a3a", "确认重置密码？", {
        confirmButtonText: "确定",
        callback: action => {
          if (action === "confirm") {
            this.$api
              .post("/admin/User/ResetPassword", { userId: val.id })
              .then(res => {
                if (res.succeed) {
                  this.$message.success("重置密码成功");
                } else {
                  this.$message.error(res.error);
                }
              });
          }
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;

      if (this.activeName == "first") {
      this.getUserList(this.currentPage, this.currentSize);
      } else if (this.activeName == "second") {
        this.getPreConfiguredUserList(this.currentPage, this.currentSize);
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      if (this.activeName == "first") {
      this.getUserList(this.currentPage, this.currentSize);
      } else if (this.activeName == "second") {
        this.getPreConfiguredUserList(this.currentPage, this.currentSize);
      }
    },
    //判空方法
    isNull(val = "") {
      if (val == undefined || val == null) {
        return true;
      }
      var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
      if (str == "" || str == undefined || str == null) {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.2rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.top-block {
  margin-top: 0.2rem;
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  .user-count-list {
    padding-left: 0.3rem;
    margin-top: 0.2rem;
    width: 85%;
    display: flex;
    justify-content: space-between;
    .user-count-item {
      display: flex;
      flex-direction: column;
      align-items: start;
      .name {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      .value {
        font-weight: bold;
        font-size: 30px;
        color: #333333;
      }
    }
  }
}

.filter {
  display: flex;
  justify-content: space-between;

  > .el-form-item {
    margin-bottom: 0;
  }
}

.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;

  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }

  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}

.userback0 {
  background-image: url("../../assets/images/userback0.png");
}

.userback1 {
  background-image: url("../../assets/images/userback1.png");
}

.userback2 {
  background-image: url("../../assets/images/userback2.png");
}

.userback3 {
  background-image: url("../../assets/images/userback3.png");
}

.userback4 {
  background-image: url("../../assets/images/userback4.png");
}

.userback5 {
  background-image: url("../../assets/images/userback5.png");
}
</style>



// WEBPACK FOOTER //
// src/view/userManagement/user.vue